import withStyles from '@material-ui/core/styles/withStyles';
import Slider from '@material-ui/core/Slider';

const styles = theme => ({
  track: {
    background: `transparent linear-gradient(90deg, ${theme.palette.facet.accentBlue} 0%, ${theme.palette.facet.accentGreen} 100%) 0% 0% no-repeat padding-box;`,
    height: '5px',
  },
  rail: {
    backgroundColor: theme.palette.facet.primaryGray,
    height: '5px',
  },
  thumb: {
    display: 'none',
  },
});

export default withStyles(styles)(Slider);
